import { ActionModal } from '@atoms/Modals';
import format from 'date-fns/format';
import React from 'react';
import { CSVLink } from 'react-csv';
import styled from 'styled-components';

type Columns = {
    label: string;
    key: string;
};

type Props = {
    listData?: any;
};

const openApplyColumn: Columns[] = [
    { label: '契約コード', key: 'contactId' },
    { label: '状態（マッチング）', key: 'acceptStatusName' },
    { label: '廃止申請日', key: '' },
    { label: '廃止NG日', key: '' },
    { label: 'マッチングエラー内容（廃止エラー）', key: '' },
    { label: 'マッチングエラー内容確認項目', key: '' },
    { label: '状態（スイッチング）', key: 'acceptStatusName' },
    { label: 'スイッチング申請日', key: '' },
    { label: 'スイッチングNG日', key: '' },
    { label: 'スイッチングエラー内容', key: '' },
    { label: 'スイッチングエラー内容確認項目', key: 'latestReceptionMessageStatusKbn' },
    { label: '再点NG日', key: '' },
    { label: '再点NG内容', key: 'latestReceptionMessageStatusKbn' },
];

const CsvDownloadOpenError = (props: Props) => {
    const fileNameDate = `swiching_error_list_${format(new Date(), 'yyyyMMdd_HHmmss')}`;
    const { listData } = props;
    const { data, error, loading } = listData;
    const openRequestListData = data || [];

    return (
        <CsvDownloadWithStyled>
            {loading && ''}
            {error && ''}
            {data &&
                <ActionModal
                    title='再点 不備一覧ダウンロード'
                    body='再点 不備一覧をダウンロードします。よろしいですか？'
                    buttonText='CSVダウンロード(不備)'
                    buttonStyle='btn-secondary'
                    element={<CSVLink className='btn btn-primary' filename={fileNameDate} headers={openApplyColumn} data={openRequestListData}>はい</CSVLink>}
                    disabled={!openRequestListData.length}
                />
            }
        </CsvDownloadWithStyled>
    );
};

const CsvDownloadWithStyled = styled.div`
`

export default CsvDownloadOpenError;